import { render } from "./VueMetamask.vue?vue&type=template&id=120eff3d&scoped=true"
import script from "./VueMetamask.vue?vue&type=script&lang=js"
export * from "./VueMetamask.vue?vue&type=script&lang=js"

import "./VueMetamask.vue?vue&type=style&index=0&id=120eff3d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120eff3d"]])

export default __exports__